import React, { useCallback, useEffect, useState } from 'react';
import ConsoleShell from '../../components/admin2/ConsoleShell';
import { candidateReason, listStaffShipping, setStaffShipping, STAFF_PAGE } from '../../lib/marketStaffShipping';

// «تسعير الشحن بواسطة الفريق» (owner, 2026-11-01). Products whose weight we
// cannot trust are marked here; the trader then sees the price without shipping
// and «اطلب عرض سعر للشحن», and the order waits in «طلبات السوق» → يحتاج إجراء,
// where the team prices the shipping (48 h to pay, the buyer is notified).
// 'candidates' is a review list only — nothing is marked without a click.

const T = {
  ar: {
    title: 'تسعير الشحن بواسطة الفريق', sub: 'المنتج المعلَّم يطلع للتاجر «السعر بدون الشحن» وزر «اطلب عرض سعر للشحن»، وطلبه يروح لـ «طلبات السوق» ← يحتاج إجراء لتسعير الشحن.',
    tabs: { candidates: 'مرشّحة للتسعير', marked: 'معلَّمة' }, why: 'مرشّحة لأن: كل الموديلات بنفس الوزن وأسعارها متباعدة 10 أضعاف أو أكثر، أو موديل وزنه فوق 100 كجم.',
    mark: 'يحتاج تسعير شحن', unmark: 'إلغاء التعليم', marked: '✓ معلَّم', note: 'ملاحظة (اختيارية)', none: 'لا شي هنا.', more: 'المزيد', open: 'صفحة المنتج',
    saved: 'حُفظ', variants: 'موديلات',
  },
  en: {
    title: 'Staff-priced shipping', sub: 'A marked product shows traders its price without shipping and «Request a shipping quote»; its order waits in Market orders → Needs action for the team to price the shipping.',
    tabs: { candidates: 'Candidates', marked: 'Marked' }, why: 'Candidates: every variant has the same weight while prices differ 10× or more, or a variant weighs over 100 kg.',
    mark: 'Needs shipping quote', unmark: 'Unmark', marked: '✓ Marked', note: 'Note (optional)', none: 'Nothing here.', more: 'More', open: 'Product page',
    saved: 'Saved', variants: 'variants',
  },
};
T.zh = T.en;

export default function ConsoleMarketStaffShipping({ user, profile, lang }) {
  const c = T[lang] || T.ar;
  const isAr = lang === 'ar';
  const [kind, setKind] = useState('candidates');
  const [rows, setRows] = useState(null);
  const [total, setTotal] = useState(0);
  const [err, setErr] = useState('');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState('');
  const [toast, setToast] = useState('');
  const flash = (m) => { setToast(m); setTimeout(() => setToast(''), 2400); };

  const load = useCallback(async (k, offset = 0) => {
    const r = await listStaffShipping(k, offset, STAFF_PAGE);
    if (!r.ok) { setErr(r.error); setRows([]); return; }
    setErr('');
    setTotal(r.total);
    setRows((prev) => (offset ? [...(prev || []), ...r.rows] : r.rows));
  }, []);
  useEffect(() => { setRows(null); load(kind); }, [kind, load]);

  const toggle = async (row, on) => {
    setBusy(row.id);
    const r = await setStaffShipping([row.id], on, note);
    setBusy('');
    if (!r.ok) { flash(r.error); return; }
    flash(c.saved);
    setRows((prev) => prev.filter((x) => x.id !== row.id));
    setTotal((n) => Math.max(0, n - 1));
  };

  return (
    <ConsoleShell user={user} profile={profile} lang={lang} active="market-staff-shipping">
      <div className="ac-page" style={{ fontFamily: isAr ? 'var(--font-ar)' : 'var(--font-sans)' }}>
        <div className="ac-page-head"><div><h1 className="ac-h1">{c.title}</h1><p className="ac-sub">{c.sub}</p></div></div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginBottom: 12 }}>
          {['candidates', 'marked'].map((k) => (
            <button key={k} type="button" className={`ac-btn ac-btn-sm${kind === k ? ' ac-btn-primary' : ''}`} data-staff-tab={k} onClick={() => setKind(k)}>
              {c.tabs[k]}{kind === k && rows ? ` · ${total.toLocaleString('en-US')}` : ''}
            </button>
          ))}
          {kind === 'candidates' && <input value={note} onChange={(e) => setNote(e.target.value)} placeholder={c.note} maxLength={500} style={{ flex: '1 1 220px', minWidth: 0, height: 34 }} />}
        </div>
        {kind === 'candidates' && <p style={{ fontSize: 12.5, color: '#666', margin: '0 0 10px' }}>{c.why}</p>}
        {err && <div className="ac-card" style={{ color: '#B4372C', marginBottom: 12 }}>{err}</div>}
        {rows === null ? <div className="ac-skel" style={{ height: 160 }} /> : rows.length === 0 ? <div className="ac-placeholder">{c.none}</div> : (
          <div className="ac-card" data-staff-rows={rows.length} style={{ padding: 0 }}>
            {rows.map((r) => (
              <div key={r.id} data-staff-row={r.id} style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', padding: '12px 14px', borderTop: '1px solid #eee' }}>
                <div style={{ flex: '1 1 320px', minWidth: 0 }}>
                  <div style={{ fontSize: 13.5 }}>{(isAr ? r.title_ar : r.title_en) || r.title_ar || r.title_en || r.id}</div>
                  <div style={{ fontSize: 12, color: '#777', marginTop: 3 }}>{kind === 'marked' ? (r.note || `${r.variants ?? '—'} ${c.variants}`) : candidateReason(r, lang)}</div>
                </div>
                <a className="ac-btn ac-btn-sm" href={`/market/${r.id}`} target="_blank" rel="noreferrer">{c.open}</a>
                {kind === 'candidates'
                  ? <button type="button" className="ac-btn ac-btn-sm ac-btn-primary" data-staff-mark={r.id} disabled={busy === r.id} onClick={() => toggle(r, true)}>{c.mark}</button>
                  : <button type="button" className="ac-btn ac-btn-sm" data-staff-unmark={r.id} disabled={busy === r.id} onClick={() => toggle(r, false)}>{c.unmark}</button>}
              </div>
            ))}
            {rows.length < total && <div style={{ padding: 12, textAlign: 'center' }}><button type="button" className="ac-btn ac-btn-sm" onClick={() => load(kind, rows.length)}>{c.more}</button></div>}
          </div>
        )}
      </div>
      {toast && <div className="ac-toast" data-toast="1">{toast}</div>}
    </ConsoleShell>
  );
}
